import {
  Card,
  DataStatus,
  Form,
  FormButton,
  FormField,
  FormSubmitHandler,
} from 'platform/components';
import {Right, VStack} from 'platform/foundation';
import {boolean, object} from 'yup';

import {useGetSAutoDefaultSettingsQuery, useSetSAutoDefaultSettingsMutation} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {useBranchId} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

type PlatformSAutoManufacturedOnFormData = {
  sAutoManufacturedOnHidden: boolean;
};

export function PlatformSAutoManufacturedOn() {
  const branchId = useBranchId();
  const {
    data: defaultSettings,
    isLoading,
    isError,
  } = useGetSAutoDefaultSettingsQuery({
    branchId,
  });
  const [saveSettings] = useSetSAutoDefaultSettingsMutation();

  const onSubmit: FormSubmitHandler<PlatformSAutoManufacturedOnFormData> = (values) =>
    saveSettings({...values, branchId})
      .unwrap()
      .catch(handleApiError);

  return (
    <Card title={i18n.t('general.labels.defaultSettings')}>
      <DataStatus isLoading={isLoading} isError={isError}>
        <Form<PlatformSAutoManufacturedOnFormData>
          defaultValues={defaultSettings}
          schema={schema}
          onSubmit={onSubmit}
          shouldWatchForUnsavedChanges
        >
          {(control) => (
            <VStack spacing={4}>
              <FormField
                control={control}
                name="sAutoManufacturedOnHidden"
                type="switch"
                label={i18n.t('page.settings.labels.sAutoManufacturedOnHidden')}
              />
              <Right>
                <FormButton
                  control={control}
                  type="submit"
                  title={i18n.t('general.actions.save')}
                />
              </Right>
            </VStack>
          )}
        </Form>
      </DataStatus>
    </Card>
  );
}

const schema = object().shape({
  sAutoManufacturedOnHidden: boolean().required(),
});
